module.exports = __webpack_public_path__ + "img/meta_tag_logo_aboutUS.1dc29469.png";